<template>
	<div id="app">
		<ScrollIndicator
			v-bind:lPos="lPos"
			v-bind:activeDecade="activeDecade"
			v-bind:rootPath="rootPath"
			v-bind:apiPath="apiPath"
			v-bind:feed="feed"
			v-bind:lastScrollY="lastScrollY"
			v-bind:needsResize="needsResize"
			v-bind:isScrolling="isScrolling"
		/>
		<Intro
			v-if="feed === 'main'"
			v-bind:rootPath="rootPath"
			v-bind:apiPath="apiPath"
			v-bind:headerpos="hPos"
		/>
		<IntroFiltered
			v-if="feed !== 'main'"
			v-bind:rootPath="rootPath"
			v-bind:apiPath="apiPath"
			v-bind:feed="feed"
		/>
		<Header
			v-bind:lPos="lPos"
			v-bind:activeDecade="activeDecade"
			v-bind:headerpos="hPos"
			v-bind:rootPath="rootPath"
			v-bind:apiPath="apiPath"
			v-bind:feed="feed"
			v-bind:isScrolling="isScrolling"
		/>
		<Decades
			v-bind:lPos="lPos"
			v-bind:rootPath="rootPath"
			v-bind:apiPath="apiPath"
			v-bind:feed="feed"
		/>
		<div id="imgEnlargeModal" v-if="imgModal !== null">
			<div class="modalbg"></div>
			<div
				class="modal-close closeX"
				v-on:click="imgModal = null"
				tabindex="-1"
			></div>
			<div class="modal-scrollable" v-on:click="imgModal = null">
				<img v-bind:src="'' + imgModal" v-on:click="imgModal = null" border="0" oncontextmenu="return false" draggable="false" />
			</div>
		</div>
	</div>
</template>

<script>
var $ = require("jquery");
import ScrollIndicator from "./components/ScrollIndicator.vue";
import Intro from "./components/Intro.vue";
import IntroFiltered from "./components/IntroFiltered.vue";
import Header from "./components/Header.vue";
import Decades from "./components/Decades.vue";

export default {
	name: "app",
	data() {
		return {
			hPos: null,
			lPos: 0,
			activeDecade: "none",
			rootPath: "/interactives/moma_through_time",
			apiPath: "",
			feed: "main",
			lastScrollY: 0,
			needsResize: false,
			isScrolling: false,
			imgModal: null
		};
	},
	created() {
		this.rootPath =
			process.env.NODE_ENV === "production"
				? "/interactives/moma_through_time/"
				: "/";
		this.apiPath =
			process.env.NODE_ENV === "production"
				? "http://54.87.134.1"
				: "//moma-archive.test";
	},
	components: {
		ScrollIndicator,
		Intro,
		IntroFiltered,
		Header,
		Decades
	},
	methods: {
		setNewURL(passedURL) {
			var stateObj = {
				pageroute: passedURL
			};

			history.pushState(stateObj, passedURL, passedURL);
			this.$gtm.trackView("Page view change", passedURL);
		}
	},
	mounted() {
		let mountThis = this;
		let scrollTimer = null;
		let scrollOffset = 0;
		let scrollBase = null;
		$(window).scroll(function() {
			mountThis.lastScrollY = $(window).scrollTop();
			if (scrollBase === null) {
				scrollBase = mountThis.lastScrollY;
			} else {
				if (mountThis.lastScrollY > scrollBase) {
					scrollOffset = mountThis.lastScrollY - scrollBase;
				} else {
					scrollOffset = scrollBase - mountThis.lastScrollY;
				}
			}
			if (scrollOffset > 100) {
				mountThis.isScrolling = true;
			} else {
				mountThis.isScrolling = false;
			}
			clearTimeout(scrollTimer);
			scrollTimer = setTimeout(function() {
				mountThis.isScrolling = false;
				scrollBase = null;
				scrollOffset = 0;
			}, 50);
		});

		// Safety nets for loading and size inits
		setTimeout(function() {
			mountThis.needsResize = true;
		}, 1000);
		setTimeout(function() {
			mountThis.needsResize = true;
		}, 2000);
	}
};
</script>

<style lang="scss">
@import "./sass/styles.scss";
</style>
